import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  body: { whiteSpace: 'break-spaces' },
});

const AlertMsg = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const handleClose = () => setOpen(false);
  const handleClick = () => {
    handleClose();
  };
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t('alert.deprecatedSos.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.body}>
          {t('alert.deprecatedSos.description')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button id="onedrive-dialog-ok" color="secondary" onClick={handleClick}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertMsg;